module.exports = __webpack_public_path__ + "static/media/46.8b76826e.png";